import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Student } from '../../../../models/student.model';

@Component({
  selector: 'app-student-edit-school',
  templateUrl: './student-edit-school.component.html',
  styleUrls: ['./student-edit-school.component.scss']
})
export class StudentEditSchoolComponent implements OnInit {

    @Input() student: Student;

    @Output() studentChange  = new EventEmitter<Student>();
    @Output() isStudentValid = new EventEmitter<boolean>();

    ngOnInit (): void {

        this.onStudentChange();

    }

    private isFormValid() : boolean {

        let isValidSchool     = this.student.school && this.student.school !== null && this.student.school !== '';
        let isValidLocation   = this.student.location && this.student.location !== null && this.student.location !== '';
        let isValidProvince   = this.student.province && this.student.province !== null && this.student.province !== '';
        let isValidPostalCode = this.student.postalCode && this.student.postalCode !== null && this.student.postalCode !== '';

        return isValidSchool && isValidLocation && isValidProvince && isValidPostalCode;

    }

    public onStudentChange() {

        let isFormValid = this.isFormValid();
        this.isStudentValid.emit(isFormValid);

        if (isFormValid) { this.studentChange.emit(this.student); }

    }
}
